import * as sites from './list'

import { Site } from 'app/types/park/site'

export const allSites: Site[] = Object.values(sites).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
